import { render, staticRenderFns } from "./OrdenCompraConsulta.vue?vue&type=template&id=149ccdaf&"
import script from "./OrdenCompraConsulta.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraConsulta.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraConsulta.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrdenCompraConsulta.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports